import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center justify-between py-2 pl-4 pr-2 rounded-sm bg-primary-100 dark:bg-gray-600" };
const _hoisted_2 = {
    key: 0,
    class: "flex items-end truncate"
};
const _hoisted_3 = { class: "flex flex-col ml-2 truncate" };
const _hoisted_4 = { class: "text-xs text-black truncate dark:text-gray-300" };
const _hoisted_5 = { class: "leading-none text-gray-400 truncate dark:text-gray-500 text-xxs" };
const _hoisted_6 = {
    key: 1,
    class: "flex items-center truncate"
};
const _hoisted_7 = { class: "ml-2 text-xs text-black truncate dark:text-gray-300" };
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectedUser',
    props: {
        user: null
    },
    emits: ['remove'],
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_Avatar = _resolveComponent("Avatar");
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                ('name' in __props.user)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_Avatar, {
                            size: "sm",
                            user: __props.user,
                            "show-tooltip": false
                        }, null, 8, ["user"]),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h1", _hoisted_4, _toDisplayString(__props.user.name), 1),
                            _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.user.email), 1)
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_Avatar, {
                            size: "sm",
                            connected: ""
                        }),
                        _createElementVNode("h1", _hoisted_7, _toDisplayString(__props.user.email), 1)
                    ])),
                _createElementVNode("button", {
                    class: "flex items-center justify-center w-6 h-6",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('remove')))
                }, [
                    _createVNode(SvgIcon, {
                        name: "search-cross",
                        class: "w-2 h-2 text-primary text-primary-300 dark:text-gray-400"
                    })
                ])
            ]));
        };
    }
});
